import {
    FETCH_GET_SEARCHER_REQUEST,
    FETCH_GET_SEARCHER_SUCCESS,
    FETCH_GET_SEARCHER_FAILURE,
} from '../../actions/searchers/get-searcher-actions';

const initialState = {
    searcher: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const GetSearcherReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_GET_SEARCHER_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_GET_SEARCHER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                searcher: action.payload,
            };
        case FETCH_GET_SEARCHER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default GetSearcherReducer;